var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-center"},[_vm._v(" 403 Нет доступа ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }